<template>
  <div class="top-videos-list-container">
    <div class="video-item video-item-header">
      <div class="item-order"></div>
      <div class="item-thumbnail"></div>
      <div class="item-detail">
        <div class="item-title">Title</div>
        <div class="item-title-subheader">Video ID</div>
        <div class="item-stats">
          <div class="stats-panel">Plays</div>
          <div class="stats-panel">Duration (Mins)</div>
        </div>
      </div>
      <div class="item-action"></div>
    </div>
    <div class="video-item" v-for="(v, index) in videos" :key="index">
      <div class="item-order">
        {{ `${index + 1} ` }}
      </div>
      <div class="item-thumbnail">
        <ImageView :source="v.coverImageUrl" />
      </div>
      <div class="item-detail">
        <div class="item-title">
          <router-link :to="generateLink(`videos/${v.videoId}`, $route.query)">
            <span class="item-title-header">{{ v.title || `Video #${v.videoId}` }}</span>
          </router-link>
        </div>
        <div class="item-title-subheader">{{ v.videoId }}</div>
        <div class="item-stats">
          <div class="stats-panel">{{ numberWithCommas(v.totalPlay) }}</div>
          <div class="stats-panel">{{ `${numberWithCommas(secondsToMinutes(v.totalWatchDurationInSeconds))}` }}</div>
        </div>
        <div class="item-stats item-stats-mobile">
          <div class="stats-panel">
            {{ transformUnit(v.totalPlay) }} views
          </div>
          <div class="icon">
            <i class="fas fa-circle"></i>
          </div>
          <div class="stats-panel">
            {{ transformUnit(secondsToMinutes(v.totalWatchDurationInSeconds)) }} mins
          </div>
        </div>
      </div>
      <div class="item-action">
        <router-link :to="generateLink(`/${teamName}/projects/${projectId}/videos/${v.videoId}`, $route.query)">
          <Button>Details</Button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import generateLink from '@/utils/generateLink';
import numberUtils from '@/utils/numberUtils';
import Button from '@/form/Button.vue';
import ImageView from '@/components/ImageView.vue';

export default {
  mixins: [numberUtils, generateLink],
  props: ['videos'],
  components: {
    Button,
    ImageView,
  },
  computed: {
    projectId() {
      return this.$route.params.projectId;
    },
    teamName() {
      return this.$route.params.teamName;
    },
  },
  methods: {
    secondsToMinutes(time) {
      return Math.round(time / 60);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.video-item {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: $spacer $spacer * 0.5;
  border-bottom: 1px solid $gray-300;

  .item-order {
    flex: 0 0 20px;
  }

  .item-title, .item-title-subheader {
    flex: 1;
  }

  .item-thumbnail {
    flex: 0 0 200px;
    display: flex;
    align-items: center;
    padding: 0 $spacer * 2;
  }

  .item-detail {
    flex: 1 0 auto;
    display: flex;
    align-items: baseline;

    .item-title, .item-title-subheader {
      flex: 2;
    }

    .item-stats {
      display: flex;
      flex-direciton: row;
      justify-content: space-evenly;
      flex: 3;

      .stats-panel {
        flex: 1 0 50%;

        .icon {
          display: none;
        }
      }

      &.item-stats-mobile {
        display: none;
      }
    }
  }

  .item-action {
    flex: 0 0 80px;
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
  }

  &:last-child {
    border: none;
  }
}


.video-item-header {
  font-weight: bold;
  align-items: flex-end;

  .item-stats {
    align-items: flex-end;
  }
}

@media (max-width: 575.98px) {

  .video-item-header {
    display: none;
  }

  .video-item {
    border: none;
    padding: 0;
    margin-bottom: $spacer * 0.75;
    justify-content: stretch;

    &:nth-child(2) {
      margin-top: $spacer;
    }

    .item-order, .item-action {
      display: none;
    }

    // .item-order {
    //   flex: 0 0 20px;
    //   font-size: $font-size-base * 0.8;
    // }

    .item-thumbnail {
      flex: 0 0 35%;
      padding: 0;
    }

    .item-detail {
      flex: auto;
      flex-direction: column;
      padding-left: $spacer * 0.5;
      align-self: baseline;

      .item-title {
        flex: auto;
        line-height: 1.2;
        margin-bottom: $spacer * 0.25;
        font-size: $font-size-base * 1.125;
      }

      .item-title-subheader {
        display: none;
        // font-size: $font-size-base * 0.8;
      }

      .item-stats {
        display: none;
      }

      .item-stats {

        &.item-stats-mobile {
          display: flex;
          flex: auto;
          width: auto;
          font-size: $font-size-base * 0.8;
          align-items: center;

          .icon {
            display: inline-block;
            font-size: 3px;
            margin-top: 2px;
            margin-right: 6px;
          }

          .stats-panel {
            flex: 1;
            margin-right: 6px;
            white-space: nowrap;
          }
        }
      }
    }

  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .video-item {
    padding: $spacer 0;

    .item-thumbnail {
      justify-content: flex-start;
      flex: 0 0 110px;
    }

    .item-action, .item-order {
      display: none;
    }
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) and (max-width: 991.98px) {
  .video-item {

    .item-thumbnail {
      flex: 0 0 120px;
    }

    .item-action {
      display: none;
    }
  }
}
</style>
